import logo from '../assets/cloudspot-logo.png';
import styles from '../styles/app.module.css';
import { TEXT } from '../texts';

export function Brand(): React.JSX.Element {
  return (
    <div className={styles.brand}>
      <img className={styles.logo} src={logo} alt="CloudSpot" width={170} height={44} />
      <span className={styles.eyebrow}>{TEXT.productName}</span>
    </div>
  );
}
